import './login-form.scss'
import Logo from 'assets/authentication/amorino-logo.svg'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FormState } from '../login/login';
import { StringStore } from 'StringStore';
import { useDispatch, useSelector } from 'react-redux';
import { auth0Login } from '../../authSlices';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AppRoutes } from '../../types/app-routes';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { jwtDecode } from "jwt-decode";
import auth0 from 'auth0-js';
import { UserRoles } from 'features/common/components/SideBar/SideBar';
import App from '@/App';
const validationSchema = Yup.object().shape({
    email: Yup.string().required('Required'),
    password: Yup.string().required('Required')
  });

export interface LoginFormProps {
    email: string;
    password: string;
}

const LoginForm = ({setFormState}) => {
    const dispatch:Function = useDispatch()
    const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated)
    const isLoading = useSelector((state: any) => state.auth.isLoading)
    const user = useSelector((state: any) => state.auth.user)
    const isFirstLogin = user?.firstLogin
    const loginError = useSelector((state: any) => state.auth.error)
    const navigate = useNavigate()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const formik = useFormik<LoginFormProps>({
        initialValues: {
          email: '',
          password: ''
        },
        validateOnMount: true,
        validationSchema,
        onSubmit: ({ email, password }) => {
            dispatch(auth0Login(email, password));
        }
      });
      
      const handleClick = (state: FormState) => {
        setFormState(state)
      }
    
      useEffect(() => {
        if (isAuthenticated && isFirstLogin){
          setFormState(FormState.FirstLogin)
          
        }
        else if(isAuthenticated){
          if(user.roleLevel >= UserRoles.MANAGER)
            navigate(AppRoutes.DASHBOARD)
          else navigate(`${AppRoutes.STOCK_MANAGEMENT}/ice-cream`)
        }
        
      }, [isAuthenticated, navigate, isFirstLogin])
  
    return (
        <div className="login-form">
            <div className="login-form__header">
              <img src={Logo} alt="Logo" className="login-form__logo"/>
              <div className="login-form__titles">
                <div className="login-form__title">{StringStore.authentication.login.title}</div>
                <div className="login-form__subtitle">{StringStore.authentication.login.subTitle}</div>
              </div>
            </div>
            <div className="login-form__inputs">
            <div className="login-form__inputs__input-combo">
              <label htmlFor="email" className='login-form__inputs__label'>{StringStore.authentication.login.email}</label>
              <InputText id="email" name={'email'} onChange={formik.handleChange} aria-describedby="email-help" className='login-form__inputs__text-input' placeholder={StringStore.authentication.login.emailPlaceholder} />
            </div>
            <div className="login-form__inputs__input-combo">
              <label htmlFor="password" className='login-form__inputs__label'>{StringStore.authentication.login.password}</label>
              <InputText id="password" type='password' name={'password'} onChange={formik.handleChange} aria-describedby="password-help" className='login-form__inputs__text-input' placeholder={StringStore.authentication.login.passwordPlaceholder} />
              <div id="password-help" className='login-form__inputs__help'>{StringStore.authentication.login.forgotPassword}<div className='login-form__inputs__click' onClick={()=>handleClick(FormState.ForgotPassword)}>{StringStore.common.clickHere}</div></div>
            </div>
              {loginError && (
                    <div className="login-form__error">
                        {loginError}
                    </div>
                )}
              <Button 
                    type='submit' 
                    disabled={!formik.isValid || isLoading} 
                    onClick={() => formik.handleSubmit()} 
                    label={isLoading ? '' : StringStore.authentication.login.buttonLabel}
                    icon={isLoading ? 'pi pi-spinner pi-spin' : undefined}
                    raised 
                    className="login-form__inputs__button" 
                />
              <div id="password-help" className='login-form__help'>{StringStore.authentication.login.noAccount}<div className='login-form__click' onClick={()=>handleClick(FormState.SignIn)}>{StringStore.authentication.login.signUp}</div></div>
            </div>
        </div>
    );
}

export default LoginForm;